import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const DeliveryMethod = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Delivery Method</InputLabel>
      <Select
        value={moduleValues?.['Delivery Method'] ?? ''}
        label="Delivery Method"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Delivery Method']: e.target.value,
          }))
        }
      >
        <MenuItem value="Mouthpiece">Mouthpiece</MenuItem>
        <MenuItem value="Face Mask">Face Mask</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default DeliveryMethod
